import React, { useState, useEffect } from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"

export const wait = ms =>
  new Promise(resove => {
    setTimeout(resove, ms)
  })

const IndexPage = () => {
  const [waited, setWaited] = useState(false)
  useEffect(() => {
    ;(async () => {
      await wait(1000)
      setWaited(true)
    })()
  }, [])

  return (
    <Layout>
      <SEO title="Home" />
      <h1>Hi people{waited && " - Worked!"}</h1>
      <p>Welcome to your new Gatsby site.</p>
      <p>Now go build something great.</p>
      <div style={{ maxWidth: `300px`, marginBottom: `1.45rem` }}>
        <Image />
      </div>
      <Link to="/page-2/">Go to page 2</Link> <br />
      <Link to="/using-typescript/">Go to "Using TypeScript"</Link>
    </Layout>
  )
}

export default IndexPage
